import { create } from 'zustand';

export interface IPreferencesStore {
  customCode?: string;
  setCustomCode: (customCode: string) => void;
}

export const usePreferencesStore = create<IPreferencesStore>()((set, get) => ({
  customCode: undefined,
  setCustomCode: (customCode) => set({ customCode }),
}));
